<template>
  <div>
    <el-form ref="versionForm" :rules="rules" label-width="80px" :model="versionForm">
      <el-form-item v-if="false" label="是否上架" prop="online">
        <el-switch v-model="versionForm.online" active-color="#1e6fff" :active-value="1" :inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item label="文件资源" prop="url">
        <el-radio-group v-model="urlType" size="mini" fill="#1e6fff">
          <el-radio-button label="internet">网络文件</el-radio-button>
          <el-radio-button label="upload" :disabled="operateType === 'edit'">上传文件</el-radio-button>
        </el-radio-group>
        <el-upload ref="versionUpload" v-show="urlType === 'upload'" class="upload-demo" drag :on-change="fileChange"
          :on-remove="removeFileList" :on-error="uploadError" :on-success="uploadSuccess"
          :data="uploadFileOptions.formData" :action="uploadFileOptions.url" :file-list.sync="fileList"
          :auto-upload="false" multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <el-input v-show="urlType === 'internet'" placeholder="文件链接" v-model="internetUrl" />
      </el-form-item>
      <el-form-item label="编译时间" prop="verdate">
        <el-date-picker :disabled="operateType === 'edit'" v-model="versionForm.verdate" type="date"
          placeholder="请输入版本编译时间" format="yyyy 年 MM 月 dd 日" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="版本号" prop="versionID">
        <el-input :disabled="operateType === 'edit'" placeholder="请输入语义化版本，例如：1.1.0-rc.1+20250720"
          v-model="versionForm.versionID"></el-input>
      </el-form-item>
      <el-form-item label="展示名称" prop="version">
        <el-input placeholder="展示给用户的版本名称" v-model="versionForm.version"></el-input>
      </el-form-item>
      <el-form-item label="发布平台" prop="platform">
        <el-radio-group :disabled="operateType === 'edit'" v-model="versionForm.platform" size="medium" fill="#1e6fff">
          <el-radio-button border label="windows">windows</el-radio-button>
          <el-radio-button border label="kylinos">银河麒麟</el-radio-button>
          <el-radio-button border label="other">其他</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发布架构" prop="arch">
        <el-input placeholder="请输入" v-model="versionForm.arch"></el-input>
      </el-form-item>
      <el-form-item label="发布说明" prop="releaseNote">
        <el-input placeholder="该版本更新内容" :rows="6" type="textarea" v-model="versionForm.releaseNote"></el-input>
      </el-form-item>
      <el-form-item label="校验和" prop="sha256">
        <el-input placeholder="sha256 校验和" v-model="versionForm.sha256"></el-input>
      </el-form-item>
    </el-form>
    <div style="display: flex;justify-content: right;">
      <div class="submit" @click="resetVersion">重置</div>
      <div class="submit primary" @click="validateAndUpload">提交</div>
    </div>
  </div>
</template>

<script>
const Semver = require('@/utils/semver.cjs')

//const crypto = require('crypto');
async function calculateSHA256(arrayBuffer) {
  // 将文件读取为ArrayBuffer
  // const arrayBuffer = await file.arrayBuffer();
  // console.log("arrayBuffer", arrayBuffer);

  console.log("calculateSHA256", arrayBuffer)
  
  // 使用Web Crypto API计算哈希
  const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
  console.log("hashBuffer", hashBuffer);

  // 将ArrayBuffer转换为十六进制字符串
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  console.log("hashHex", hashHex);

  return hashHex;
}

export default {
  name: 'versionOperate',
  components: {},
  props: {
    operateType: {
      type: String,
      default: "add"
    },
    editInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 初始化编辑的信息
      if (this.operateType === 'edit' && this.editInfo) {
        this.versionForm = JSON.parse(JSON.stringify(this.editInfo));
        this.urlType = "internet"
        this.internetUrl = this.editInfo.url
      } else if (this.operateType === 'add') {
        // 默认为当前时间
        this.versionForm.verdate = new Date()
      }
    })
  },
  data() {
    return {
      rules: {
        // sha256: [
        //   { required: true, message: '请输入sha256校验和', trigger: ['blur', 'change'] },
        //   { pattern: /^[a-fA-F0-9]{64}$/, message: "SHA-256 校验和是由 64 个十六进制数字符构成的字符串", trigger: ['blur', 'change'], }
        // ],
        // verdate: [
        //   { required: true, message: '请输入版本时间', trigger: ['blur', 'change'] },
        //   // { pattern: /^\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/, message: "请输入正确格式的时间，例如20230606", trigger: ['blur', 'change'], }
        // ],
        online: [
          { required: true, message: '请选择是否上架', trigger: ['blur', 'change'] },
        ],
        version: [
          { required: true, message: '请输入版本名称', trigger: ['blur', 'change'] },
        ],
        url: [
          { required: true, validator: this.urlValidatePass, trigger: ['blur', 'change'] }
        ],
        versionID: [
          { required: true, message: '请输入版本号', trigger: ['blur', 'change'] },
          { 
            // 正则表达式来自https://semver.org/lang/zh-CN/
            pattern: /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.?(0|[1-9]\d*)?(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/, 
            message: "主版本.次版本.修订版本-先行版本标签+编译信息(例: 1.1.1-rc.1+20250701)", 
            trigger: ['blur', 'change'], 
          }
        ],
        platform: [
          { required: true, message: '请选择发布平台', trigger: ['blur', 'change'] },
        ],
        arch: [
          { required: true, message: '请输入发布架构', trigger: ['blur', 'change'] },
        ]
      },
      urlType: 'upload',
      internetUrl: '',
      versionForm: {
        online: 1,
        sha256: '',
        releaseNote: '',
        platform: 'windows',
        arch: "",
        url: '',
        verdate: '',
        version: '',
        versionID: ''
      },
      fileList: [],
      fileIsChange: false,
      uploadFileOptions: {
        url: "https://upload.qiniup.com",
        name: "file",
        formData: {
          token: "",
          key: ""
        }
      },
    }
  },
  methods: {
    urlValidatePass(rule, value, callback) {
      if (this.urlType === 'internet') {
        // 网络文件
        if (!this.internetUrl) {
          callback(new Error('请输入文件链接'));
        } else {
          // 正则表达式是从 https://urlregex.com/ 获取的，这是一个专门提供url验证正则表达式的网站。
          const urlRegex = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/
          const isValidUrl = urlRegex.test(this.internetUrl)
          if (!isValidUrl) {
            callback(new Error('请输入合法的文件链接地址'));
          } else {
            callback();
          }
        }
      } else if (this.urlType === 'upload') {
        // 上传文件
        if (this.fileList.length === 0) {
          callback(new Error('请选择文件'));
        }
      }
      callback();
    },
    resetVersion() {
      if (this.operateType === 'edit' && this.editInfo) {
        this.versionForm = JSON.parse(JSON.stringify(this.editInfo));
        this.urlType = "internet"
        this.internetUrl = this.editInfo.url
      } else {
        this.$refs.versionForm.resetFields();
        this.urlType = "internet"
        this.internetUrl = ""
      }
    },
    changeFormByFileName(filename)
    {
      console.log("changeFormByFileName");
      console.log({filename});
      // 正则表达式来自https://semver.org/lang/zh-CN/
      let semver = Semver.extract(filename);
      console.log(semver)
      if(semver.valid)
      {
        if(semver.prerelease().includes("windows") || semver.prerelease().includes("kylin"))
        {
          semver.setPrerelease("");
        }
      }else{
        let match = filename.match(/(d+).(d+).(d+).(d+)/)
        if(match)
        {
          let version = `${match[1]}.${match[2]}.${match[3]}+${match[4]}`;
          semver.setVerion(version)
        }
      }
      // verdate
      {
        let match = filename.match(/(20[0-9]{2})([0-9]{2})([0-9]{2})[^0-9]/);
        if(!match)
          match = filename.match(/([0-9]{2})([0-9]{2})([0-9]{2})[^0-9]/);
        if(!match)
          match = filename.match(/(20[0-9]{2})?([0-9]{2})([0-9]{2})[^0-9]/);
        console.log({match});
        if(match)
        {
          let date = new Date();
          let year = match[1] || "2025"
          if(year.length <= 2)
            year = "20" + year;
          date.setFullYear(year || 2025);
          date.setMonth(match[2]-1);
          date.setDate(match[3]);
          this.versionForm.verdate = date;
        }
      }
      // build
      if(!semver.build())
      {
        const formattedVerdate = this.versionForm.verdate.toLocaleDateString("zh", { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '');
        semver.setBuild(formattedVerdate);
      }
      console.log({semver});
      this.versionForm.versionID = semver.longVersion();
      // platform
      if(filename.includes("windows"))
      {
        this.versionForm.platform = "windows"
      }else if(filename.includes("kylin"))
      {
        this.versionForm.platform = "kylinos";
      }else{
        this.versionForm.platform = "windows";
      }
      // arch
      if(filename.includes("x86"))
      {
        if(this.versionForm.platform == "kylinos")
          this.versionForm.arch = "x86_64"
        else
          this.versionForm.arch = "x86"
      }else if(filename.includes("x64"))
      {
        if(this.versionForm.platform == "kylinos")
          this.versionForm.arch = "x86_64"
        else
          this.versionForm.arch = "x64"
      }else if(filename.includes("arm64"))
      {
        this.versionForm.arch = "arm64"
      }else{
        this.versionForm.arch = "x64"
      }
      let platform = this.versionForm.platform;
      if(platform == "kylinos")
        platform = "kylin"
      this.versionForm.version = `${semver.version()}-${platform}-${this.versionForm.arch}`;

    },
    async checkAdminToken({message="请输入令牌", title="提示"} = {}){
      let {value} = await this.$prompt(message, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder:"请输入令牌"
      });
      try{
        const res = await this.$callApi({
            name: "admin.checkToken",
            data: { token: value.trim() },
            config: { method: "post" }
        });
        if (res.status == 0 && res.data) {
          return true;
        } else {
          // this.$message.error('令牌错误， 请重试')
        }
        return false;
      }catch(e)
      {
        return false;
      }
    },
    // 校验表单通过后，则上传文件
    async validateAndUpload() {
      try {
        await this.$refs.versionForm.validate()
        let semver = Semver.extract(this.versionForm.versionID);
        if(!semver.valid)
        {
          this.$message.error("版本号格式不正确")
        }
        else
        {
          if(!semver.prerelease())
          {
            let value = await this.checkAdminToken({message:"您正在发布正式版本，请输入操作令牌"});
            if(!value){
              this.$message.error('操作令牌错误， 请重试')
              return;
            }
          }
        }
        if (this.operateType === 'add') {
          await this.addFileValidate()
        } else if (this.operateType === 'edit') {
          this.editVersionSubmit()
        }
      } catch (error) {
        console.warn('获取参数错误', error)
      }
    },
    async addFileValidate() {
      if (this.urlType === 'upload') {
        await this.setUploadFileOptions()
        this.$refs.versionUpload.submit();
        // 在文件上传成功的钩子函数中进行表单的提交
      } else if (this.urlType === 'internet') {
        this.versionForm.url = this.internetUrl
        this.addVersionSubmit()
      }
    },
    // 获取前端上传所需参数
    async setUploadFileOptions() {
      console.log('fileList', this.fileList)
      const versionID = this.versionForm.versionID;
      let minorVersion = versionID;
      let semver = Semver.extract(versionID);
      if(semver.valid){
        minorVersion = semver.minorVersion();
      }

      const verdate = new Date(this.versionForm.verdate);
      const formattedVerdate = verdate.toLocaleDateString("zh", { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '');

      const filename = this.fileList[0].name

      const cloudDir = `archive/atk/v${minorVersion}/${formattedVerdate}/`.replace(/\./g, '-').replace(/\+/g, '-')
      const cloudPath = cloudDir + filename;
      console.log('cloudPath', cloudPath)

      const res = await this.$callApi({
        name: "getUploadFileOptions",
        data: {
          cloudPath
        },
        config: { mask: true, method: "post" }
      })
      const uploadFileOptionsRes = res.data
      console.log('uploadFileOptionsRes ', uploadFileOptionsRes)
      this.uploadFileOptions = uploadFileOptionsRes.uploadFileOptions
      // 等待 DOM 更新，要不然 data、action 不会是最新的参数
      await this.$nextTick();
    },
    // 限制上传一个文件
    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用（但是文件移除不会调用）
    async fileChange(file, fileList) {
      console.log('文件改变file', file)
      console.log('文件改变fileList', fileList)
      this.fileIsChange = true
      this.fileList = fileList.slice(-1);
      console.log(this.fileList);
      if(this.fileList[0])
      {
        let theFile = this.fileList[0];
        let rawfile = theFile.raw;
        console.log(rawfile);
        let reader = new FileReader();
        reader.readAsArrayBuffer(rawfile);
        reader.onload = async ()=>{
          console.log("onload", reader.result);
          let sha256 = await calculateSHA256(reader.result);
          console.log({sha256});
          this.versionForm.sha256 = sha256;
        }
        this.changeFormByFileName(theFile.name);
      }
    },
    // 文件列表移除钩子
    removeFileList(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    // 文件上传失败时的钩子
    uploadError(err, file, fileList) {
      const errMessage = JSON.parse(err.message)
      const errString = errMessage.error || ''
      console.error('文件上传失败', err)
      this.$message.error(`文件上传失败！${errString}`)
    },
    uploadSuccess(response, file, fileList) {
      console.log('uploadSuccess')
      if (response.key) {
        this.versionForm.url = `${this.$GLOBAL_CDN_URL}/${response.key}`
        this.addVersionSubmit()
      } else {
        this.$message.error('文件上传发生错误，请联系管理员')
      }
    },
    // 新增
    async addVersionSubmit() {
      console.log('新增')
      try{
        const res = await this.$callApi({
          name: "addVersion",
          data: this.versionForm,
          config: { mask: true, method: "post" }
        })
        if (res.status === 0) {
          this.$emit('addSuccess')
        } else {
          this.$message.error(res.message);
        }
      }catch(e)
      {
        this.$message.error({message: e.message, duration:0});
      }
    },
    // 编辑
    async editVersionSubmit() {
      console.log('表单编辑', this.versionForm)
      try{
        const res = await this.$callApi({
          name: "updateVersion",
          data: this.versionForm,
          config: { mask: true, method: "post" }
        })
        if (res.data.updated) {
          this.$emit('editSuccess')
        } else {
          this.$message.error(res.message);
        }
      }catch(e)
      {
        this.$message.error({message: e.message, duration:0});
      }
    },
  },
}
</script>
<style lang="less" scoped>
.submit {
  padding: 5px 10px;
  color: #fff;
  width: max-content;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 15px;
  border: 1px solid #dcdfe6;
  color: #606266;

  &.primary {
    background-color: #1e6fff;
    border: 1px solid #1e6fff;
    color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/version/versionOperate.vue